module.exports = __webpack_public_path__ + "img/se-list-a.8ce0ad1f.png";